import store from '@/store';
export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: "主键id",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "进件编号",
      prop: "businessCode",
      type: "input",
      search: true,
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      type: "input",
    },
    {
      label: "产品类型",
      prop: "rentType",
      type: "select",
      dicData: store.getters.porductTypes
    },
    {
      label: "产品类型",
      prop: "rentTypeList",
      type: "select",
      hide: true,
      search: true,
      searchMultiple: true,
      dicData: store.getters.porductTypes
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      search: "true"
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      type: "input",
    },
    {
      label: "放款时间",
      prop: "lendingTime",
      type: "daterange",
      valueFormat: "yyyy-MM-dd",
      dataType: "object",
      search: true,
      searchRange: true
    },
    {
      label: "所属代理商",
      prop: "businessDeptIdList",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: "类型",
      prop: "operatorSource",
      type: "select",
      search: true,
      dicData: [
        {
          label: "逾期未还",
          value: 1
        },
        {
          label: "合同违约",
          value: 2
        },
        {
          label: "其他",
          value: 99
        }
      ],
    },
  ]
};
